(ns practitest.frontend.forms3.entity-form.fields
  (:require [ajax.core :as ajax]
            [practitest.frontend.pt-ts-bridge :as pt-ts :refer [GenericSearchableTree]]
            [clojure.string :as str]
            [cljs.reader]
            [practitest.frontend.common.ai-text-enhancement :as ai-text-enhancement]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.components.datepicker :as datepicker]
            [practitest.frontend.components.datepicker2 :as datepicker2]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.run-status :as run-status2]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.components.markdown3 :as markdown3]
            [practitest.frontend.components.selector2 :as selector2]
            [practitest.frontend.components.navigation :as navigation]
            [practitest.frontend.components.overflow :as overflow]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.events :as events]
            [practitest.frontend.kanban :as kanban]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.components.forms :as forms1]
            [practitest.frontend.components2.entity-form.jira-user-list-input :as jira-user-list]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.gherkin-textarea :as gherkin-textarea]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.test-type :as test-type]
            [practitest.frontend.components2.value-score :as value-score]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.forms3.entity-form.collab-events :as collab-events]
            [clojure.set]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

;; Taking two first letters and capitalizing them
;; e.g.
;; "Administrators" -> "A"
;; "Team 7" -> "T7"
;; "Our Very Brave Testers" -> "OV"
(defn- group-name->initials
  [name]
  (when name
    (str/join (map (comp first str/capitalize)
                   (take 2 (str/split name #"\s"))))))

(defn group-avatar
  [group]
  (let [name (:name group)]
    [:div.avatar-holder.group-avatar
     [:span.new-avatar-icon.group-avatar
      (group-name->initials name)]]))

(defn user-item-renderer
  [{:keys [selected? hover? on-hover on-change label-fn inner-ref item multi?]}]
  (let [type (:type item)
        name (:name item)
        id (:id item)
        avatar (:avatar item)]
    [:div.selector-item
     {:class         (dom/classes-pairs :active selected?
                                        :hover hover?)
      :ref           inner-ref
      :on-mouse-over on-hover
      :on-mouse-move on-hover
      :on-click      (fn [e]
                       (when on-change
                         (on-change item)))}

     (case type
       "group"
       [group-avatar item]

       "user"
       [navigation/user-avatar2 item]

       ;; else
       nil)

     [overflow/overflow-with-mux-tooltip
      {}
      (fn [props]
        [:span.selector-item-text
         props
         name])
      name]]))

(defn selected-user-renderer
  [{:keys [show? value label-fn]}]
  [:div.selector-current-item
   {:class (dom/classes-pairs :expanded show?)}
   (when-let [name (:name value)]
     [:<>
      [navigation/user-avatar2 value]

      [overflow/overflow-with-mux-tooltip
       {}
       (fn [props]
         [:span.selector-item-text
          props
          name])
       name]])])

(defn- update-field-state
  [{:keys [get-field-state
           set-field-state
           field-id]
    :as   field-props} update-fn & params]
  (set-field-state field-id (apply update-fn @(get-field-state field-id) params)))

(defn- reset-field-state
  [{:keys [set-field-state
           reconcile-form
           field-id]
    :as   field-props}]
  (set-field-state field-id nil)
  (reconcile-form))

(defn- set-field-value
  [{:keys [validators]
    :as   field-props}
   new-value]

  (update-field-state field-props
                      assoc
                      :value new-value
                      :dirty? true
                      :errors (forms1/validate-all validators new-value)))

;; XXX: we're temporarily disabling field indication because it caused a very large increase in WS traffic

(defn- send-field-focus-message [props]
  (when false
    (re-frame/dispatch [::events/send-field-message :field-focus props])))

(defn- send-field-blur-message [props]
  (when false
    (re-frame/dispatch [::events/send-field-message :field-blur props])))

;; XXX: End of disabling field indication

(defn field-editing-indicators
  "Returns list of editing users for styling the field border and tooltips"
  [{:keys [field-id form-id entity-id]}]
  (when (and field-id form-id entity-id)
    (let [entity-form-id (str (name form-id) "-" entity-id)
          editing-users @(re-frame/subscribe [::collab-events/field-editing-users entity-form-id field-id])]
      editing-users)))

(defn rules-class [field-props suffix]
  (str "rules_engine_"
       (if (:custom? field-props) "cf_" "sf_")
       (:id field-props)
       suffix))

;; Base control - both for edit and create modes
(defn base-control
  [_]
  (fn [{:keys [field-id
               get-field-state
               label
               mandatory?
               title?
               read-only?]
        :as   props}
       editing-field
       readonly-field]
    (let [field-state @(get-field-state field-id)
          errors (:errors field-state)
          description? (= field-id :description)
          editing-users (field-editing-indicators props)
          has-editing-users? (seq editing-users)]
      [:div.g2-field-container
       {:class (dom/classes-pairs-v
                 (rules-class props "_all") true
                 "description-field" description?)}
       (when (and (not title?)
                  (not description?))
         [:label.m-label {:for   field-id
                          :class (dom/classes-pairs-v
                                   :description description?
                                   (rules-class props "_label") true)}
          label (when mandatory?
                  [:span.mandatory "*"])])
       (when has-editing-users?
         (map-indexed
           (fn [idx editing-user]
             (let [user-initials (fu/user-initials (:name editing-user))
                   user-color (:color editing-user)]
               ^{:key (:id editing-user)}
               [tooltip/mux-tooltip
                {:position "top"}
                (:name editing-user)
                (fn [tooltip-props]
                  [:div.field-indication (assoc tooltip-props
                                                :style {:color user-color
                                                        :border-color user-color
                                                        :right (str (+ (if description? 20 10) (* idx 30)) "px")}
                                                :class (when description? "description-field-indication"))
                   [:div.user-initials user-initials]
                   [icons/field-indicator-icon {:style {:color user-color}}]])]))
           editing-users))

       [:div.input-with-message-container
        {:class (dom/classes-pairs "field-being-edited" has-editing-users?)
         :style (when has-editing-users?
                  {"--editing-user-color" (-> editing-users first :color)})}
        (if-not read-only?
            ;; Splice some props into child component
          (let [[component props & children] editing-field]
            (into [component
                   (assoc props :errors errors)]
                  children))
          [:div.m-readonly-field.flex-full {:id field-id}
           readonly-field])

          ;; Show errors for both read-only and editing fields (used in e.g. Jira edit modal)
        (when (seq errors)
          [:div.validation-error-message (str/join "," (mapv :message errors))])]])))

(defn- update-field-definition
  [db data]
  ;; TODO: get rid of empty vector
  (let [field (events/convert-field [] data)]
    (assoc-in db [:fields (:name field)] field)))

(defn added-list-value [{db :db} [_ field-props value response]]
  {:db         (-> db
                   (update :progress disj ::add-list-value)
                   (update-field-definition (:data response)))
   :dispatch-n [[::notifications/success2
                 (get-translation "testset.notification.new-list-value-added" "New list value added")
                 {:auto-close 1000}]
                ;; Select new value in list
                [::events/set-field-value (:entity-type field-props) (:name field-props) value]]})

(re-frame/reg-event-fx
  ::added-list-value
  added-list-value)

(defn add-list-value [{db :db}
                      [_ field-props value]]
  {:db (update db :progress conj ::add-list-value)
   :http-xhrio
   {:method          :post
    :uri             (let [path-params {:project_id (subs/get-current-project-id db)
                                        :p_id       (subs/get-current-project-id db)
                                        :id         (:id field-props)}]
                       (if (:system? field-props)
                         (broutes/get-url "system_fields#add_list_value2" path-params)
                         (broutes/get-url "custom_fields#add_list_value2" path-params)))

    :params          {:value value}
    :format          (ajax/json-request-format)
    :response-format (ajax/json-response-format {:keywords? true})

    :on-success      [::added-list-value field-props value]
    :on-failure      [::events/api-error ::add-list-value {}]}})

(re-frame/reg-event-fx
  ::add-list-value
  add-list-value)

;; TODO: fix this on backend
(defn try-parse-multilist-value [raw-multilist-string]
  (when (string? raw-multilist-string)
    (try
      (if (str/starts-with? raw-multilist-string "[")
        ;; We're assuming here that multilist formatting is EDN-compatible
        (cljs.reader/read-string raw-multilist-string)
        ;; In some scenarios (like list -> multilist conversion)
        ;; It's possible that we have simple "string" as single element
        [raw-multilist-string])
      (catch js/Error e
        (js/console.warn e)))))

(defn on-jira-values-refreshed [{db :db} [_ field-props response]]
  (let [field-name (:name field-props)]
    {:db       (-> db
                   (update :progress disj ::refresh-jira-values)
                   (assoc-in [:fields field-name :possible-values] (:values response)))
     :dispatch [::notifications/success2
                (get-translation "field.notification.jira-values-refreshed" "Field values refreshed from Jira")
                {:auto-close 2000}]}))

(re-frame/reg-event-fx
  ::on-jira-values-refreshed
  on-jira-values-refreshed)

(defn refresh-jira-values [{db :db} [_ field-props]]
  {:db (update db :progress conj ::refresh-jira-values)
   :http-xhrio {:method          :post
                :uri             (broutes/get-url "integration_setting_jira_two_ways#refresh_field_values"
                                                  {:project_id              (subs/get-current-project-id db)
                                                   :integrated_bugtracker_id (subs/get-current-integration-id db)})
                :params          {:field_id   (:id field-props)
                                  :field_type (if (:system? field-props) "system" "custom")}
                :format          (ajax/json-request-format)
                :response-format (ajax/json-response-format {:keywords? true})
                :on-success      [::on-jira-values-refreshed field-props]
                :on-failure      [::events/api-error ::refresh-jira-values
                                  {:message (get-translation "field.notification.jira-values-refresh-failed"
                                                             "Failed to refresh values from Jira")}]}})

(re-frame/reg-event-fx
  ::refresh-jira-values
  refresh-jira-values)

(defn on-add-value
  [field-props value]
  (let [tags? (:tags? field-props)
        value (if tags?
                value
                (js/prompt "Enter new field value"))
        value (fu/validate-new-list-value! value)]
    (when value
      (if tags?
        (re-frame/dispatch [::add-tags (set [value])])
        (re-frame/dispatch [::add-list-value field-props value])))))

(defn allowed-transitions
  [list-transitions user-groups base-value label-fn]
  (let [user-groups-set (set user-groups)]
    (->> list-transitions
         ;; Keep only transitions allowed for the user's groups or for all (empty group list)
         (filter (fn [[[from _to] allowed-groups]]
                   (or (empty? allowed-groups)
                       (not-empty (clojure.set/intersection user-groups-set (set allowed-groups))))))
         ;; Only transitions that start from the current base-value
         (filter #(= (label-fn base-value) (ffirst %)))
         ;; Collect the destination labels
         (map #(second (first %)))
         set)))

(defn base-list-control
  [{:keys [clear-linked-lists

           field-id
           errors
           type
           multi?
           value
           add?

           tags?

           possible-values

           mandatory?

           label-fn
           key-fn

           list-transitions
           user-groups
           base-value

           on-change
           on-add-value-fn
           on-refresh-values
           selector-item-renderer
           selected-item-renderer
           close-on-mouse-leave?]
    :as   props}]
  [base-control
   props
   ;; Selector view
   [selector2/new-select {:items                  (if (and (seq list-transitions) base-value)
                                                    (let [possible-transitions (allowed-transitions list-transitions user-groups base-value label-fn)]
                                                      (filter #(or (contains? possible-transitions (label-fn %))
                                                                   (= base-value %))
                                                              possible-values))
                                                    possible-values)
                          :id                     field-id
                          :label-fn               label-fn
                          :key-fn                 key-fn

                          :selector-item-renderer (or selector-item-renderer
                                                      (when (= :user type)
                                                        user-item-renderer))
                          :selected-item-renderer (or selected-item-renderer
                                                      (when (= :user type)
                                                        selected-user-renderer))

                          :placeholder            (get-translation "generic.list.placeholder" "Select value")
                          :clearable?             (if (contains? props :clearable?) (:clearable? props) (not mandatory?))

                          :on-add-value           (when add?
                                                    (fn [item]
                                                      (if on-add-value-fn
                                                        (on-add-value-fn item)
                                                        (on-add-value props item))))
                          :on-refresh-values      on-refresh-values
                          :multi?                 multi?
                          :tags?                  tags?
                          :class                  (dom/classes-pairs :errors (seq errors)
                                                                     (rules-class props "_val") true)
                          :value                  value
                          :on-focus               (fn [e]
                                                    (send-field-focus-message props))
                          :on-blur                (fn [e]
                                                    (send-field-blur-message props))
                          :on-close               (fn [e]
                                                    (send-field-blur-message props))
                          :close-on-mouse-leave?  close-on-mouse-leave?
                          :on-change              (fn [value]
                                                    (when on-change
                                                      (on-change value))

                                                    (when clear-linked-lists
                                                      (clear-linked-lists field-id))

                                                    ;; Send blur message when value is selected
                                                    (send-field-blur-message props))}]
   ;; Readonly view
   [:span
    {:class (dom/classes-pairs (rules-class props "_val") true)}
    ;; TODO: something more sophisticated ?
    (when (= :run_status field-id)
      (if (nil? value)
        [:<>
         [:span.run-status-color {:style {:background (run-status2/get-status-color "NO RUN")}}]
         [:span (run-status2/get-status-label "NO RUN")]]
        [:span.run-status-color {:style {:background (run-status2/get-status-color (:id value))}}]))
    (when (= :test_type field-id)
      [:span.me-2
       (test-type/get-type-icon (:id value))])
    (if multi?
      (str/join ", " (map label-fn value))
      (label-fn value))]])

(defn text-input
  [{:keys [type
           value
           edit?
           errors
           ref
           field-id
           placeholder
           max-length
           autofocus?
           disabled?
           on-blur]
    :as   field-props}]
  [:input.m-input
   {:ref         (dom/ref-handler ref)
    :placeholder placeholder
    :id          field-id
    :class       (dom/classes-pairs :errors (seq errors)
                                    (rules-class field-props "_val") true)
    :type        (case type
                   :number "number"
                   :num_of_results "number"
                   ;; else
                   "text")
    :value       value
    :max-length  max-length
    :autoFocus   (boolean autofocus?)
    :disabled    (boolean disabled?)
    :on-focus    (fn [e]
                   (send-field-focus-message field-props))
    :on-blur     (fn [e]
                   (send-field-blur-message field-props)
                   (when on-blur
                     (on-blur e)))
    :on-change   (fn [e]
                   (set-field-value field-props (dom/event-value e)))}])

(defn glb-prefixed-text-input
  [{:keys [errors] :as field-props}]
  [:div.glb-prefixed-input
   {:class (dom/classes-pairs :errors (seq errors))}
   [:span.glb-prefix "🌐"]
   [text-input (assoc field-props :max-length 30)]])

(defn checkbox-control-editing
  [{:keys [value
           errors
           ref
           field-id
           on-change]
    :as   field-props}]
  [:input.m-checkbox.m-entity-checkbox
   {:ref       (fn [node]
                 (when ref
                   (ref node)))
    :id        field-id
    :class     (dom/classes-pairs :errors (seq errors)
                                  (rules-class field-props "_val") true)
    :type      "checkbox"
    :checked   (if (or (= value true)
                       (=  value "yes"))
                 true
                 false)
    :on-change on-change}])

(defn url-field
  [{:keys [value read-only? class] :as field-props}]
  (let [common-props {:on-click (fn [e] (dom/stop-propagation e))
                      :class     (str (dom/classes-pairs-v :m-readonly-field read-only?) " " class)
                      :target    "_BLANK"}]
    (cond
      (string? value)
      [:a (merge common-props {:href value :title value})
       value]

      (map? value)
      (let [url (:url value)
            title (:title value)]
        [:a (merge common-props {:href url :title url})
         title]))))

(defn icon-controls
  [{:keys [on-clear on-save editing?]}]
  [:div.selector-controls-holder.url-input-icons
   [:span.selector-clear-value
    {:on-click (fn [e]
                 (dom/stop-propagation e)
                 (on-clear))}
    [icons/mux-x]]

   [:div.selector-controls-delimiter]

   (if editing?
     [:span.selector-save-value
      {:on-click (fn [e]
                   (dom/stop-propagation e)
                   (on-save))}
      [icons/check-circle]]

     [:span.selector-edit-value
      {:on-click (fn [e]
                   (dom/stop-propagation e)
                   (on-save))}
      [icons/mux-pencil]])])

(defn editable-url-field
  [{:keys [value field-id] :as props}]
  (let [editing?  (reagent/atom (str/blank? value))
        local-val (reagent/atom value)
        input-ref (reagent/atom nil)
        save!     #(do (set-field-value props @local-val)
                       (reset! editing? false))
        clear!    #(do (reset! local-val "")
                       (set-field-value props ""))]

    (reagent/create-class
      {:component-did-update
       (fn [this]
         (let [val (:value (reagent/props this))]
           (when (and (some? val)
                      (not= val @local-val))
             (reset! local-val val)
             (reset! editing? (str/blank? val)))))

       :reagent-render
       (fn []
         (if @editing?
           ;; Edit mode
           [:div.url-field-wrapper
            [:input.m-input.truncate-url
             {:ref         #(reset! input-ref %)
              :type        "text"
              :value       @local-val
              :id          field-id
              :on-change   #(let [new-val (.. % -target -value)]
                              (reset! local-val new-val)
                              (set-field-value props new-val))
              :on-key-down (fn [e]
                             (case (.-key e)
                               "Enter"  (save!)
                               "Escape" (do (reset! local-val value)
                                            (reset! editing? false))
                               nil))
              :on-focus (fn []
                          (send-field-focus-message props))
              :on-blur  (fn []
                          (send-field-blur-message props))}]
            [icon-controls
             {:editing? true
              :on-clear clear!
              :on-save  save!}]]

           ;; View mode
           [:div.url-field-wrapper
            [url-field (assoc props :value @local-val
                              :class "truncate-url")]
            [icon-controls
             {:editing? false
              :on-clear (fn []
                          (reset! editing? true)
                          (clear!))
              :on-save (fn []
                         (set-field-value props @local-val)
                         (reset! editing? true))}]]))})))

(defn checkbox-control-readonly
  [{:keys [type
           value
           read-only?
           errors
           ref
           field-id]
    :as   field-props}]
  [:input.m-checkbox.m-readonly-checkbox
   {:ref       (fn [node]
                 (when ref
                   (ref node)))
    :id        field-id
    :class     (dom/classes-pairs :errors (seq errors))
    :type      "checkbox"
    :checked   (if (or (= value true)
                       (=  value "yes"))
                 true
                 false)
    :on-change (fn [_])}])

(re-frame/reg-event-db
  ::add-tags
  (fn [db [_ new-tags]]
    (update db :tags
            (fn [existing-tags]
              ;; TODO: fix this, so ugly
              (let [etags (set (map first existing-tags))
                    ntags (clojure.set/difference new-tags etags)]
                ;; only add new tags here
                (apply conj existing-tags
                       (map #(vector % 0) ntags)))))))

(defn- memo-on-drag-over [local-state e]
  (set! (.-dropEffect (.-dataTransfer e)) "copy")
  (dom/prevent-default e)
  (swap! local-state assoc :dragged-over? true))

(defn- memo-on-drag-leave [local-state e]
  (dom/prevent-default e)
  (swap! local-state assoc :dragged-over? false))

(defn- on-file-paste [local-state field-info on-files-attached file file-name]
  (let [file-info {:name (.-name file)
                   :size (.-size file)
                   :type (.-type file)}]
    (when on-files-attached
      (on-files-attached field-info [file]))))

(defn- memo-on-drop [local-state field-info on-files-attached e]
  (dom/prevent-default e)

  (swap! local-state assoc :dragged-over? false)

  (let [files (.-files (.-dataTransfer e))]
    (when (and on-files-attached
               ;; Only trigger event if there are actual files dropped
               (seq files))
      (on-files-attached field-info files))))


(defn get-user-id [value]
  (when value
    ;; We can have various user representations
    (cond
      ;; It's a map with full user data
      (map? value)
      (:id value)

      (number? value)
      value

      ;; String can be of two types - just a number or something like "User-<id>"
      (string? value)
      (if (str/starts-with? value "User-")
        (fu/try-parse-number (str/replace-first value #"User-" ""))
        (fu/try-parse-number value))

      :else
      (js/console.warn "Unhandled case for user-id" (type value) value))))

(defn requirement-searchable-tree [props field-props]
  (let [current-project @(re-frame/subscribe [::subs/current-project])
        current-user @(re-frame/subscribe [::subs/current-user])
        user-id (str (:id current-user))
        project-id (str (:id current-project))]
    [:> GenericSearchableTree
     {:onChange (fn [%]
                  (let [js-obj (js->clj % :keywordize-keys true)]
                    (set-field-value props (:id js-obj))))
      :customClassName "parent-searchable-tree"
      :selectedValue (:value props)
      :idsToRemove [(str (:entity-id props))]
      :urls        {:fetchTreeNode (broutes/get-url "requirements#fetch_parent_node"  {:p_id project-id})
                    :search (broutes/get-url "requirements#search_parent"  {:p_id project-id})
                    :fetchRootTreeUrl    (broutes/get-url "requirements#fetch_parent_tree" {:p_id project-id})}
      :scope {:module (:entity-type props)
              :tab "requirements"
              :user-id user-id
              :project-id project-id}}]))

(defn folder-searchable-tree [props field-props]
  (let [current-project @(re-frame/subscribe [::subs/current-project])
        current-user @(re-frame/subscribe [::subs/current-user])
        user-id (str (:id current-user))
        project-id (str (:id current-project))]
    [:> GenericSearchableTree
     {:onChange (fn [%]
                  (let [js-obj (js->clj % :keywordize-keys true)]
                    (set-field-value props (:id js-obj))))
      :on-focus (fn [e]
                  (send-field-focus-message props))
      :on-blur (fn [e]
                 (send-field-blur-message props))
      :customClassName "parent-searchable-tree"
      :selectedValue (:value props)
      :urls        {:fetchRootTreeUrl    (broutes/get-url "folders#by_entity" {:p_id project-id} {:entity_name (:entity-type props) :views_count -1})
                    :fetchTreeNode (broutes/get-url "folders#fetch_folder"  {:p_id project-id}  {:entity_name (:entity-type props)})
                    :search (broutes/get-url "folders#search"  {:p_id project-id}  {:folder_type (:entity-type props)})}
      :scope {:module (:entity-type props)
              :tab  "folders"
              :user-id user-id
              :project-id project-id}}]))

(defn gherkin-textarea-panel
  [{:keys [field-id get-field-state] :as field-props}]
  (let [edit? (reagent/atom false)
        container-ref (atom nil)
        listener-fn (fn [e]
                      (when (and (not (.contains @container-ref (.-target e)))
                                 @edit?)
                        (reset! edit? false)
                        (when-let [cm @gherkin-textarea/cm-container]
                          (.setOption cm "readOnly" "nocursor")
                          (.setOption cm "lineNumbers" false))))
        listener-name-fn (fn [e]
                           (let [new-name (.-value (.-target e))]
                             (when-let [cm @gherkin-textarea/cm-container]
                               (let [current-text (.getValue cm)
                                     updated-text (clojure.string/replace
                                                    current-text
                                                    #"(?i)(Scenario Outline:|Scenario:)\s*(.*)"
                                                    (fn [[_ prefix _]] (str prefix " " new-name)))]
                                 (when (not= current-text updated-text)
                                   (.setValue cm updated-text))))))]

    (reagent/create-class
      {:reagent-render
       (fn [{:keys [field-id get-field-state] :as field-props}]
         (let [value (:value @(get-field-state field-id))]
           [:div.gherkin-container.gherkin-container-form3
            {:ref #(reset! container-ref %)}
            [:label
             [:span.pe-3 "Scenario"
              [:span.mandatory "*"]]]
            [:div {:class    (when-not @edit? "clickable disabled")
                   :on-click (fn [_]
                               (when-not @edit?
                                 (reset! edit? true)
                                 (when-let [cm @gherkin-textarea/cm-container]
                                   (.setOption cm "readOnly" false)
                                   (.setOption cm "lineNumbers" true))))}
             [gherkin-textarea/gherkin-editor-form3
              {:value     value
               :edit?     @edit?
               :field-id  field-id
               :on-change (fn [new-value]
                            (set-field-value field-props new-value))
               :on-change2 (fn [new-value]
                             (set-field-value (assoc field-props :field-id :name) new-value))}]]]))

       :component-did-mount
       (fn []
         (.addEventListener js/document "mousedown" listener-fn)
         (when-let [name-el (.getElementById js/document "name")]
           (.addEventListener name-el "input" listener-name-fn)))

       :component-will-unmount
       (fn []
         (.removeEventListener js/document "mousedown" listener-fn)
         (when-let [name-el (.getElementById js/document "name")]
           (.removeEventListener name-el "input" listener-name-fn)))})))

(defn build-test-type-field
  [_ _]
  (let [state (reagent/atom {:selected-type "ScriptedTest"})]
    (fn [{:keys [field-name
                 edit-permissions?
                 set-active-tab-fn]
          :as   field-props}
         {:keys [get-field-state
                 get-field-props
                 get-form-state]
          :as   form-props}]
      (let [field-props @(get-field-props field-name)
            {:keys [value
                    errors]
             :as   field-state} @(get-field-state field-name)

            props (merge form-props
                         field-props
                         {:value      value
                          :errors     errors
                          :read-only? (if edit-permissions?
                                        (:read-only? field-props)
                                        true)})

            custom-test-types-order ["ScriptedTest" "ExploratoryTest" "BDDTest" "AutomatedTest"]
            enabled-automation-types @(re-frame/subscribe [::subs/enabled-automation-types])
            possible-values (->> (:possible-values props)
                                 (remove #(contains? test-type/automated-test-types %))
                                 (sort-by #(.indexOf custom-test-types-order %))
                                 ;; Remove automated when none of the automation types is enabled.
                                 (remove #(and (= % "AutomatedTest")
                                               (not (seq enabled-automation-types)))))

            selected-type (:selected-type @state)]

        [:div.test-types-container
         [:span.title
          (str (get-translation "generic.fields.select-test-type.label"
                                "Select Test Type") ":")]

         (into [:div.test-types-options]
               (map (fn [test-type]
                      (let [icon (:icon (get test-type/types-map test-type))
                            label (:title (get test-type/types-map test-type))
                            is-automated? (= test-type "AutomatedTest")
                            is-selected? (= selected-type test-type)]
                        ^{:key test-type}
                        [buttons/button
                         {:test-id (str "test-type-" test-type)
                          :class (str "test-type-option" (when is-selected? " selected"))
                          :toolbar? true
                          :on-click (fn []
                                      (if is-automated?
                                         ; if "AutomatedTest" is clicked, select "ApiTest" and show radio buttons
                                        (do
                                          (swap! state assoc :selected-type "AutomatedTest"
                                                 :selected-radio "ApiTest")
                                          (set-field-value props "ApiTest")
                                          (set-active-tab-fn :automation))
                                         ; otherwise, select the clicked test type
                                        (do
                                          (swap! state assoc :selected-type test-type
                                                 :selected-radio nil)
                                          (set-field-value props test-type))))
                          :icon [icon]
                          :text (if is-automated? "Automated" label)}]))
                    possible-values))]))))

(defn test-type-field-radio-btns
  [_ _]
  (let [state (reagent/atom {:selected-radio "ApiTest"})]
    (fn [{:keys [field-name]
          :as   field-props}
         {:keys [get-field-state
                 get-field-props]
          :as   form-props}]
      (let [field-props @(get-field-props field-name)
            {:keys [value errors] :as field-state} @(get-field-state field-name)

            props (merge form-props
                         field-props
                         {:value      value
                          :errors     errors})

            automation-type-map {"api"         "ApiTest"
                                 "firecracker" "FirecrackerTest"
                                 "xbot"        "xBotTest"}

            enabled-automation-types @(re-frame/subscribe [::subs/enabled-automation-types])

            radio-options ["ApiTest" "FirecrackerTest" "xBotTest"]
            enabled-types-set (set (map automation-type-map enabled-automation-types))
            relevant-radio-options (filterv #(contains? enabled-types-set %) radio-options)

            selected-radio (:selected-radio @state)]

        (when (and (seq relevant-radio-options)
                   (not (some #(= selected-radio %) relevant-radio-options)))
          (let [selected-option (first relevant-radio-options)]
            (swap! state assoc :selected-radio selected-option)
            (set-field-value props selected-option)))

        [:div.test-type-radio-options-container
         [:span.title
          (str (get-translation "generic.fields.select-automation-test-type.label"
                                "Select The Type Of Automation Test") " ?")
          [:span.mandatory "*"]]

         (map (fn [test-type]
                ^{:key test-type}
                (let [label (:label (get test-type/types-map test-type))]
                  [:label.test-type-radio-option
                   [:input.me-2 {:type      "radio"
                                 :name      "automated-test-radios"
                                 :value     test-type
                                 :checked   (= selected-radio test-type)
                                 :on-change (fn []
                                              (swap! state assoc :selected-radio test-type)
                                              (set-field-value props test-type))}]
                   label]))
              relevant-radio-options)]))))

(defn editable-test-status?
  "Returns true if the current user is allowed to edit the test status based on transition rules."
  [base-value user-groups list-transitions]
  (if (and base-value (seq list-transitions))
    (some (fn [[[from _to] allowed-groups]]
            (and (= from base-value)
                 (or (empty? allowed-groups)
                     (not-empty (clojure.set/intersection user-groups (set allowed-groups))))))
          list-transitions)
    true)) ; default to true

(defn test-status-read-only?
  [base-value user-groups list-transitions field-props edit-locked?]
  (cond
    (editable-test-status? base-value user-groups list-transitions) false
    edit-locked? true
    :else (:read-only? field-props)))

(defn special-editable-field?
  "Allows certain fields to be editable on locked test forms."
  [field-id]
  (contains? #{:tags :folder_id :assigned_to} field-id))

(defn workflow-read-only-field?
  "Determines if the field should be read-only based on workflow rules."
  [field-id base-value user-groups list-transitions
   field-props form-props edit-permissions? edit-locked?]
  (cond
    ;; No permission → always read-only
    (not edit-permissions?) true

    ;; Not a test entity → defer to field props
    (not= (:entity-type form-props) :test)
    (:read-only? field-props)

    ;; Field is test_status → use dedicated logic
    (= field-id :test_status)
    (test-status-read-only? base-value user-groups list-transitions
                            field-props edit-locked?)

    ;; Locked test field and not a special editable one → read-only
    (and edit-locked?
         (not (special-editable-field? field-id)))
    true

    ;; Fallback → use field props
    :else (:read-only? field-props)))

(defn split-list-item-renderer
  [{:keys [selected? hover? on-hover on-change inner-ref item]}]
  (if-not (map? item)
    [:div.selector-item (str item)]
    (let [section (:section item)
          section-class (str "split-list-" (when section (name section)))]
      (if (:is-header item)
        [:div.split-list-header-item.selector-item
         {:class (dom/classes-pairs :active selected? :hover hover? section-class true)
          :ref inner-ref
          :on-mouse-over on-hover
          :on-mouse-move on-hover}
         [:span.header-text (:header-label item)]]
        [:div.selector-item
         {:class (dom/classes-pairs :active selected? :hover hover? section-class true)
          :ref inner-ref
          :on-mouse-over on-hover
          :on-mouse-move on-hover
          :on-click (fn [e]
                      (when on-change
                        (on-change item)))}
         (str (:label item))]))))

(defn split-list-selected-renderer
  [value section-values-map section-indicators-map]
  (if value
    (let [display-value (if (map? value) (:label value) value)
          section (first (keep (fn [[section-id values]]
                                 (when (some #{display-value} values)
                                   section-id))
                               section-values-map))
          section-name (if section (name section) "unknown")
          section-indicator (or (get section-indicators-map section) "")]
      [:div.split-list-selected-item
       {:class (str "split-list-" section-name)}
       [:span.selected-value-label display-value]
       [:span.selected-value-badge section-indicator]])
    nil))

(defn build-field
  [_ _]

  (let [project @(re-frame/subscribe [::subs/current-project])
        local-state (reagent/atom {})
        textarea-ref (atom nil)]
    (fn [{:keys [field-name
                 issue_type_id
                 edit-permissions?
                 ref]
          :as   field-props}
         {:keys [set-field-state
                 get-field-state
                 get-field-props
                 get-form-state
                 new?
                 on-files-attached
                 edit-locked?
                 use-test-workflow?]
          :as   form-props}]
      (let [field-props @(get-field-props field-name)
            {:keys [editing?
                    value
                    errors]
             :as   field-state} @(get-field-state field-name)

            {:keys [base-entity]
             :as   form-state} @(get-form-state)

            field (:field field-props)
            field-id (:field-id field-props)
            field-type (case field-id
                         :parent_id :parent_id
                         (:type field-props))
            field-info {:textarea-ref textarea-ref
                        :field-id field-id}

            base-value value
            user-groups (set (:user-groups field-props))
            list-transitions (:list-transitions field-props)
            snapshot? (false? (:current base-entity))

            ;; Merge both form and field-props
            ;; TODO: cleanup a little bit
            props (merge form-props
                         field-props
                         {:value      value
                          :errors     errors
                          :ref ref
                          :read-only? (or snapshot?
                                          (if use-test-workflow?
                                            (workflow-read-only-field? field-id base-value user-groups list-transitions
                                                                       field-props form-props edit-permissions? edit-locked?)
                                            (if edit-permissions?
                                              (:read-only? field-props)
                                              true)))})]
        (case field-type
          :memo
          (let [description? (= field-id :description)
                placeholder (case field-id
                              :description (str (get-translation "generic.fields.placeholder.description" "Add Description") "...")
                              :charter (str (get-translation "generic.fields.placeholder.charter" "Add Charter") "...")
                              :guide_points (str (get-translation "generic.fields.placeholder.guide_points" "Add Guide Points") "...")
                              :scenario (str (get-translation "generic.fields.placeholder.scenario" "Add Scenario") "...")
                              :automated_test_design (str (get-translation "generic.fields.placeholder.automated_test_design" "Add Test Design") "...")
                              "")
                form-id (:form-id form-props)
                loading-ref (reagent/atom nil)
                {:keys [ai-loading? ai-enhanced-text footer-content]}
                (when description?
                  (ai-text-enhancement/get-ai-enhancement-state
                   form-id
                   :main  ;; context-id for regular description fields
                   field-id
                   value
                   (and edit-permissions? (not snapshot?))
                   loading-ref))]

            ;; Scroll to loading state when it becomes active
            (when (and description? ai-loading?)
              (reagent/after-render
               (fn []
                 (when-let [loading-element @loading-ref]
                   (.scrollIntoView loading-element #js {:behavior "smooth" :block "center"})))))

            [base-control
             props
             [markdown3/markdown-editor (cond->
                                         {:editing? true
                                          :id field-id
                                          :value value
                                          :placeholder placeholder
                                          ;; Special case for description field
                                          :class (dom/classes-pairs :description description?)
                                          :preview-class (if description?
                                                           :description
                                                           :memo)
                                          :on-change (fn [value]
                                                       (set-field-value props value))
                                          :on-focus (fn [e]
                                                      (send-field-focus-message props))
                                          :on-blur (fn [e]
                                                     (send-field-blur-message props))
                                          :textarea-ref textarea-ref
                                          :users (when description? (:users props))
                                          :on-drag-over (reagent/partial memo-on-drag-over local-state)
                                          :on-drag-leave (reagent/partial memo-on-drag-leave local-state)
                                          :on-drop (reagent/partial memo-on-drop local-state field-info on-files-attached)
                                          :on-load-file (reagent/partial on-file-paste local-state field-info on-files-attached)}

                                         description?
                                         (assoc :footer-content footer-content
                                                :external-fullscreen? (or ai-loading? (some? ai-enhanced-text))
                                                :on-fullscreen-exit (fn []
                                                                      (re-frame/dispatch [::ai-text-enhancement/exit-enhancement-fullscreen form-id :main field-id]))))]
             [markdown3/markdown-editor (cond->
                                           {:read-only? true
                                            :preview-class (if description?
                                                             :description
                                                             :memo)
                                            :class (dom/classes-pairs :description description?)
                                            :value value}

                                           description?
                                           (assoc :footer-content footer-content
                                                  :external-fullscreen? (or ai-loading? (some? ai-enhanced-text))
                                                  :on-fullscreen-exit (fn []
                                                                        (re-frame/dispatch [::ai-text-enhancement/exit-enhancement-fullscreen form-id :main field-id]))))]])

          :kanban_lane
          [base-list-control
           (assoc props :label-fn :name
                  :value (kanban/find-lane value (:possible-values props))
                  :key-fn (fn [lane idx]
                            (:lane_id lane))
                  :on-change (fn [value]
                               (set-field-value props value))
                  :simple? false)]

          :tags
          [base-list-control
           (assoc props :multi? true
                  :tags? true
                  :add? true
                  :label-fn :label
                  :value (set (map (fn [tag]
                                     {:id    tag
                                      :label tag})
                                   value))
                  :on-change (fn [tags]
                               (set-field-value props (set (map :id tags))))
                  :possible-values (mapv (fn [[tag count]]
                                           {:id    tag
                                            :label tag})
                                         (:possible-values props)))]
          ;; Lists are mostly the same, with slight differences
          :jira_user_list
          [jira-user-list/jira_user_list
           (assoc props
                  :label-fn (or (:label-fn field-props) :label)
                  :key-fn (or (:key-fn field-props)
                              (fn [item idx]
                                (str idx "-" (:id item))))
                  :base-value (get base-entity field)
                  :external-id (:external_id base-entity)
                  :issue_type_id issue_type_id
                  :on-change (fn [base_value]
                               (let [id (:value base_value)
                                     label (:label base_value)] 
                                 (set-field-value props (:id base_value)))))]

          ;; Lists are mostly the same, with slight differences
          (:multilist :list)
          (let [multi? (= :multilist field-type)
                ;; Special raw-list support - can override label-fn and key-fn and no possible values conversion
                raw-list? (:raw-list? field-props)
                label-fn (or (:label-fn field-props)
                             :label)
                key-fn (or (:key-fn field-props)
                           ;; Current DB has same values in multilist/lists and that messes up
                           ;; with default key-fn that uses :id, so we're using index here as well
                           (fn [item idx]
                             (str idx "-" (:id item))))
                possible-values (if raw-list?
                                  (:possible-values props)
                                  (map (fn [v]
                                         {:id    v
                                          :label v})
                                       (:possible-values props)))
                value (if raw-list?
                        value
                        (if multi?
                          (set
                              ;; TODO: fix this multilist issue
                            (for [v (if (string? value)
                                      (try-parse-multilist-value value)
                                      value)]
                              {:id    v
                               :label v}))
                          (when (some? value)
                            {:id    value
                             :label (if (= field-id :test_type)
                                      (test-type/get-type-label value)
                                      value)})))

                ;; Base value is in "entity-format" but we need it here in "form-format"
                base-value (get base-entity field)
                base-value (when (some? base-value)
                             {:id    base-value
                              :label base-value})]
            [base-list-control
             (assoc props :value value
                    :base-value base-value
                          ;:trace? true
                    :label-fn label-fn
                    :key-fn key-fn
                    :multi? multi?
                    :add? (and (not multi?)
                               (:allow-add-list-value? field-props)
                               (not (:jira-mapped? field-props)))
                    :on-refresh-values (when (:jira-mapped? field-props)
                                         #(re-frame/dispatch [::refresh-jira-values field-props]))
                    :on-change (fn [value]
                                 (if raw-list?
                                   (set-field-value props value)
                                   (set-field-value props (if multi?
                                                                  ;; TODO: fix this
                                                            (js/JSON.stringify (clj->js (mapv :label value)))
                                                            (:label value)))))
                    :possible-values possible-values)])

          :linkedlist
          (let [parent-value (:value @(get-field-state (:parent_list_field_name props)))
                options (when parent-value
                          (get (:possible-values props) parent-value))
                first-option (first options)
                current-value (if value
                                {:label value
                                 :id    value}
                                nil)]
            ;; Auto-populate first option when field is dirty (user changed parent) but empty
            ;; do not auto-populate on page reload (if value was deleted from the field)
            (when (and (not (seq value))
                       (seq parent-value)
                       first-option
                       (or (:dirty? field-state)
                           (:new? props)))
              (js/setTimeout #(set-field-value props first-option) 0))

            [base-list-control
             (assoc props :value current-value
                    :label-fn :label
                  ;; Same as for multilist - we allow duplicate values for now
                    :key-fn (fn [item idx]
                              (str idx "-" (:id item)))
                    :on-change (fn [value]
                                 (set-field-value props (:label value)))
                    :possible-values (map (fn [v]
                                            {:id    v
                                             :label v})
                                          options))])

          :split-list
          (let [sections (or (:sections field-props) [])
                section-values-map (into {} (map (fn [section]
                                                   [(:id section) (or (:values section) [])])
                                                 sections))
                section-indicators-map (into {} (map (fn [section]
                                                       [(:id section) (or (:indicator section) (:label section))])
                                                     sections))
                all-items (vec (mapcat (fn [section]
                                         (let [section-values (or (:values section) [])
                                               section-id (:id section)
                                               header-label (:label section)
                                               items (mapv (fn [v] {:id v :label v :section section-id :is-header false}) section-values)
                                               header (when (seq items) {:id (str section-id "-header")
                                                                         :header-label header-label
                                                                         :section section-id
                                                                         :is-header true})]
                                           (concat (when header [header]) items)))
                                       sections))]
            [base-list-control
             (assoc props
                    :clearable? false
                    :close-on-mouse-leave? true
                    :possible-values all-items
                    :label-fn (fn [item]
                               (cond
                                 (nil? item) ""
                                 (map? item) (:label item)
                                 :else (str item)))
                    :key-fn (fn [item idx]
                            (str (:section item) "-" idx "-" (:id item)))
                    :selector-item-renderer split-list-item-renderer
                    :selected-item-renderer (fn [{:keys [value]}]
                                             (split-list-selected-renderer value section-values-map section-indicators-map))
                    :on-change (fn [selected-item]
                                 (when (and selected-item (not (:is-header selected-item)))
                                   (if (:on-change field-props)
                                     ((:on-change field-props) selected-item)
                                     (set-field-value props selected-item))))
                    :add? (:allow-add-list-value? field-props)
                    :on-add-value-fn (:on-add-value-fn field-props))])

          :user
          (let [user-id (get-user-id value)
                ;; Special assigned_to handling
                field-type (or (:type value) "user")

                ;; TODO: rework user handling between frontend and backend
                user (first (filter #(and (= (:type %) field-type)
                                          (= (:id %) user-id))
                                    (:possible-values props)))]
            [base-list-control
             (assoc props :label-fn (fn [user]
                                      (let [user-name (:name user)
                                            name-value (:name value)]
                                        [:div.selector-current-item
                                         [navigation/user-avatar2 user] (or user-name name-value)]))
                    :value user
                    :on-change (fn [user]
                                 (set-field-value props user))
                    :key-fn (fn [user idx]
                              (str (:type user) "-" (:id user))))])

          :folder_id
          [base-control
           props
           [folder-searchable-tree (assoc props :folder-id value) field-props]
           value]

          (:checkbox :boolean)
          [base-control
           props
           [checkbox-control-editing
            (assoc props
                   :on-change (fn [e]
                                (set-field-value props (if (dom/event-value e)
                                                         "yes"
                                                         "no"))))]
           [checkbox-control-readonly props]]

          :url
          [base-control
           props
           [editable-url-field props]
           [url-field props]]

          :glb-prefixed-text
          [base-control
           props
           ;; editing control - globe icon prefix is non-editable
           [glb-prefixed-text-input props]
           ;; readonly control
           (str "🌐 " value)]

          (:text :number :num_of_results)
          [base-control
           props
           ;; editing control
           [text-input props]
           ;; readonly control
           (cond
             (= :url field-type) [url-field props]
             (= :value_score field-id) [value-score/value-score-field value]
             :else value)]

          :bdd-scenario
          (let [props (assoc props :disabled-edit? false
                             :label "")]
            [base-control
             props
             [gherkin-textarea-panel props]
             value])

          :milestone
          (let [key-fn (or (:key-fn field-props)
                           (fn [item idx]
                             (str idx "-" (:id item))))
                possible-values (map (fn [v]
                                       {:id    (first v)
                                        :label (last v)})
                                     (:possible-values props))
                value (when (some? value)
                        {:id    (:id value)
                         :label (:label value)})]
            [base-list-control
             (assoc props :value value
                    :label-fn :label
                    :key-fn key-fn
                    :on-change #(set-field-value props {:id (:id %)
                                                        :label (:label %)})
                    :possible-values possible-values)])

          (:linked_milestones :milestones)
          [base-list-control
           (assoc props :multi? true
                  :label-fn :label
                  :possible-values (map (fn [i]
                                          (let [[id label] i]
                                            {:label label :id id}))
                                        (get-in props [:all-fields :milestone_id :possible-values]))
                  :on-change (fn [value]
                               (set-field-value props (map
                                                        #(vector (:id %) (:label %))
                                                        value)))
                  :value (into #{}  (map (fn [[id label]]
                                           {:id id :label label}) value)))]

          :date
          [base-control
           props
           [datepicker2/date-picker-input
            (assoc props :class (dom/classes-pairs :m-input true
                                                   :errors (seq errors))
                   :id field-id
                   :time? false
                   :on-focus (fn [e]
                               (send-field-focus-message props))
                   :on-blur (fn [e]
                              (send-field-blur-message props))
                   :on-change (fn [e]
                                (set-field-value props e)))]
           (fu/formatted-local-date value)]

          :date-time
          [base-control
           props
           [datepicker/instant-picker
            (assoc props :class "form-control m-input"
                   :field-id field-id
                   :on-change (fn [e]
                                (set-field-value props e)))]
           (if (and (= :last_run field-id)
                    (nil? value))
             [:span
              (get-translation "generic.label.never_run" "Never Run")]
             (fu/formatted-date-time value))]

          :duration
          [base-control
           props
           [text-input props]
           value]

          :parent_id
          [base-control
           props
           [requirement-searchable-tree (assoc props :value value) field-props]
           value]

          ;; default
          [:pre
           (with-out-str
             (println "field" name)
             (cljs.pprint/pprint field-props))])))))
             ;(println "props")
             ;(cljs.pprint/pprint props)

(defn two-panel-selector
  "Generic two-panel click-to-move component for selecting items from a list.

   Parameters:
   - available-items: seq of items not yet selected
   - selected-items: seq of items already selected
   - item-renderer: fn(item, options) -> hiccup to render the item
   - search-value: current search query string
   - on-search-change: fn(e) callback when search input changes
   - on-item-click: fn(item) callback when item is clicked
   - loading?: boolean indicating if items are loading
   - left-panel-title: string for left panel header
   - right-panel-title: string for right panel header
   - empty-state-left: string message when no available items
   - empty-state-right: string message when no selected items
   - on-scroll: fn(e) callback for infinite scroll in left panel
   - search-box?: boolean, whether to show search box (default: true)
   - class-prefix: string CSS class prefix (default: 'two-panel')
   - item-key-fn: fn(item, index) -> react key (default: index as string)
   "
  [{:keys [available-items selected-items item-renderer
           search-value on-search-change on-item-click loading?
           left-panel-title right-panel-title
           empty-state-left empty-state-right on-scroll
           search-box? class-prefix item-key-fn]
    :or {search-box? true
         class-prefix "two-panel"
         item-key-fn (fn [item idx] (str idx))}}]

  [:div {:class (str class-prefix "-panels")}
   ;; Left Panel - Available Items
   [:div {:class (str class-prefix "-panel " class-prefix "-available")}
    [:div {:class (str class-prefix "-panel-header")}
     [:h4 {:class (str class-prefix "-panel-title")} left-panel-title]]
    (when search-box?
      [:div {:class (str class-prefix "-search")}
       [:input.m-input
        {:type "text"
         :placeholder (or (:search-placeholder :search-placeholder) "Search...")
         :value search-value
         :on-change on-search-change}]])
    [:div {:class (str class-prefix "-panel-list")
           :on-scroll on-scroll}
     (if (and loading? (empty? available-items))
       [:div {:class (str class-prefix "-panel-loading")}
        [spinners/mux-spinner {:size :medium}]
        [:p "Loading..."]]
       (if (empty? available-items)
         [:p {:class "text-muted empty-state"} empty-state-left]
         (doall (map (fn [item idx]
                      (let [key (if item-key-fn
                                  (item-key-fn item idx)
                                  (str idx))]
                        ^{:key key}
                        [item-renderer item
                         {:on-click (when on-item-click
                                     (fn [e]
                                       (.stopPropagation e)
                                       (on-item-click item)))
                          :clickable? true}]))
                    available-items
                    (range)))))]]

   ;; Right Panel - Selected Items
   [:div {:class (str class-prefix "-panel " class-prefix "-selected")}
    (when search-box?
      [:div {:class (str class-prefix "-search-spacer")}])
    [:div {:class (str class-prefix "-panel-header")}
     [:h4 {:class (str class-prefix "-panel-title")}
      (str right-panel-title " (" (count selected-items) ")")]]
    [:div {:class (str class-prefix "-panel-list")}
     (if (empty? selected-items)
       [:p {:class "text-muted empty-state"} empty-state-right]
       (doall (map (fn [item idx]
                    (let [key (if item-key-fn
                                (item-key-fn item idx)
                                (str idx))]
                      ^{:key key}
                      [item-renderer item
                       {:on-click (when on-item-click
                                   (fn [e]
                                     (.stopPropagation e)
                                     (on-item-click item)))
                        :clickable? true
                        :selected? true}]))
                  selected-items
                  (range))))]]])
